<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="validationObserver">
    <form @submit.prevent="handleSubmit(submit)" ref="form">
      <div :class="inList ? 'page-container py-0' : 'page-container bg-white '">
        <SearchFilters
        :showSearchBox="showSearchBox"
        @businessChange="handleBusinessChange"
        @branchChange="handleBranchChange"
        @update:searchQuery="searchQuery = $event"
        />
        <FormGenerator :Fields="Fields" :model="data" :options="options" />
        <div>
            <hr/>
            <div class="fw-bold h5 text-grey">Advertisement</div>
          </div>
          <SliderAds :branchId="branchId" :businessId="businessId" :imagesData="data.SliderAds" @updateImages="handleSliderAdsUpdate"/>
        <div class="text-right">
          <b-spinner v-if="loading" variant="primary" label="Spinning" ></b-spinner>
          <b-button v-else variant="primary" type="warning" native-type="submit"
            >Submit</b-button
          >
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import SearchFilters from "@/components/SearchFilters.vue";
import { Fields, models, options } from "./form_fields";
import { listBranchSetting, setBranchSetting } from "@/API/BranchesAPIs";
import FormGenerator from "@/components/FormGenerator/FormGenerator.vue";
import { AppSettings } from "@/config/constant";
import SliderAds from "./SliderAds.vue";

export default {
  name: "MobileAppSettingsTab",
  props: ["id", "model"],
  components: {
    SearchFilters,
    FormGenerator,
    SliderAds
  },
  data() {
    return {
      loading: false,
      businessId: null,
      branchId: null,
      showSearchBox: false,
      data: JSON.parse(JSON.stringify(models)),
      options: options,
      Fields: Fields,
      emptyModel: null,
      inList: false,
      rules: {
        Address: [
          { required: true, message: "Please enter the name", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
    filteredLocalizedItems() {
      return this.items
        .map(item => {
          const localizedData =
            item.locales.find(locale => locale.locale === this.currentLocale) ||
            item.locales[0];
          return {
            ...item,
            name: localizedData.name || "",
            description: localizedData.description || ""
          };
        })
        .filter(item =>
          item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
    },
    userBusinesses() {
      return this.$store.state.User.user.business || [];
    },
    userBranches() {
      return this.userBusinesses.find(b => b.id === this.businessId)?.branches || [];
    }
  },

  watch: {
    businessId(newBusinessID) {
      const business = this.userBusinesses.find(b => b.id === newBusinessID);
      this.branchId = business?.branches?.[0]?.id || null;
    },
    userBusinesses: {
      handler(newBusinesses) {
        if (newBusinesses.length > 0 && !this.businessId) {
          this.businessId = newBusinesses[0].id;
        }
      },
      deep: true
    },
    userBranches: {
      handler(newBranches) {
        if (newBranches.length > 0 && !this.branchId) {
          this.branchId = newBranches[0].id;
          if (this.branchId && this.businessId) {}
        }
      },
      deep: true,
    },
    businessId(newBusinessID) {
      const business = this.userBusinesses.find(b => b.id === newBusinessID);
      this.branchId = business?.branches?.[0]?.id || null;
      this.getData()
    },
  },
  async mounted() {},
  methods: {
    handleSliderAdsUpdate(newSliderData) {
      if (!this.data.SliderAds) {
        this.data.SliderAds = [];
      }
      this.data.SliderAds = newSliderData;
    },
    handleBusinessChange(newValue) {
      if (newValue !== this.businessId) {
        this.businessId = newValue;
      }
    },
    handleBranchChange(newValue) {
      if (newValue !== this.branchId) {
        this.branchId = newValue;
      }
    },
    async resetForm() {
      this.data = JSON.parse(this.emptyModel);
      await this.getData();
    },
    async getData() {
      this.data = { ...JSON.parse(this.emptyModel) };
      var settingData = await listBranchSetting({
        businessId: this.businessId,
        branchId: this.branchId
      });
      let mobileSettings = _.filter(settingData, {
        key: AppSettings.MobileAppSettings
      });
      if (mobileSettings && mobileSettings.length)
        mobileSettings[0]?.data?.forEach(set => {
          this.$set(this.data, set.key, set.data);
        });
    },

    modelToSubmitDataConverter() {
      var data = [];
      for (const [key, value] of Object.entries(this.data)) {
        if (value !== null && value !== "" && key !== null && key !== "") {
          data.push({ key: key, data: value });
        }
      }
      return [{ key: AppSettings.MobileAppSettings, data }];
    },
    async submit() {
      this.loading = true;
      let submitData = this.modelToSubmitDataConverter();
      await setBranchSetting(
        this.businessId,
        this.branchId,
        submitData
      );
      this.loading = false;
    }
  }
};
</script>

<style scoped></style>
